import * as React from 'react'
import classnames from 'classnames'
import { css } from 'emotion'
import { LifeInsuranceOffer } from 'ui/multi-product/constants/models'
import LoadingIndicator, { BRAND_COLOR } from 'embed/components/LoadingIndicator'
import { Product } from 'even-ts-static'
import { ListItem } from '../ListItem'

interface OfferListProps {
  loadingCustomizedOffer: boolean
  offers: LifeInsuranceOffer[]
  selectedTab: string
}

export const OfferList: React.FC<OfferListProps> = ({ loadingCustomizedOffer, offers, selectedTab }) =>
  loadingCustomizedOffer ? (
    <div
      className={classnames(css`
        margin-bottom: 24px;
      `)}
    >
      <LoadingIndicator
        brandColor={BRAND_COLOR.TRUE}
        loadingLabel="Searching our network of top rated carriers"
        showPendingOriginators={false}
        product={Product.LifeInsurance}
      />
    </div>
  ) : (
    <div key={selectedTab}>
      {offers.map((offer) => (
        <ListItem key={offer.uuid} offer={offer} />
      ))}
    </div>
  )
